/**
 * Returns true when the user has entered or changed any values from the defaults,
 * or when a JSON payload has been pasted into the load field.
 */
export function hasPayloadProgress<TState>(
  state: TState,
  loadJson: string,
  createDefaultState: () => TState,
  snapshot: (state: TState) => string,
): boolean {
  if (loadJson.trim()) return true;
  return snapshot(state) !== snapshot(createDefaultState());
}
